import { Guid } from "@/Common/Models/Guid";
import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { PrescriptionMedicationStatus } from "@/Common/Models/Patient/PatientEnums";
import { EnumPatientSummaryMedicationDisplayStatus } from "@/Patient/Models/MedicalSummary/MedicalItemMedicationDisplayStatus";
import { BaseCareElement } from "./BaseCareElement";
import { CareElementType } from "./CareElementType";
import { Dosage } from "./Dosage";

class ActiveMedicationCareElement extends BaseCareElement {
    public CareElementType: CareElementType.ActiveMedication;
    public Id: Guid;
    public Name: string;
    public SummaryDisplayStatus: EnumPatientSummaryMedicationDisplayStatus;
    public RefillStartDate: Date;
    public CeaseDate?: Date;
    public RefillEndDate?: Date;
    public Dosages: Dosage[];
    public RefillQuantity?: string;
    public InitialRefillQuantity?: string;
    public NumberOfRefill?: number;
    public TotalDurationManualDays?: number;
    public IsCeased: boolean;
    public LegalStatus?: string;
    public TotalDurationManual?: number;
    public Form?: string;
    public DrugStrength?: string;
    public PrescriptionMedicationStatus: PrescriptionMedicationStatus;

    public constructor(init: NonFunctionProperties<Omit<ActiveMedicationCareElement, "CareElementType">>) {
        super();
        Object.assign(this, init);
    }
}

export { ActiveMedicationCareElement };
